__webpack_require__.p = "https://slog.kncept.com/";